<template>
  <article class="our-people">
    <div class="container">
      <HeroesMainHero
        v-if="hero && (hero.title?.value || hero.body?.value)"
        :main-hero="{
          intro: {
            icon: hero.icon ?? null,
            title: hero.title ?? null,
            body: hero.body ?? null,
          },
          img: hero.image,
          article: hero.links,
        }" />
      <div class="content-block two-column-text">
        <h1 v-if="title" v-bind="useEpiAttrs(title)">{{ title.value }}</h1>
        <BlocksWerkenbijContentArea v-if="body" :content="body" />
      </div>
    </div>
    <div class="content-block-full our-people__slider">
      <SlidersColleaguesSlider v-if="persons" :data="persons" />
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { ContentResponseModel, OurPeoplePageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { hero, persons, body, title } = props.data.content as OurPeoplePageResponseModel;
</script>

<style lang="scss" scoped>
.our-people {
  > .container {
    grid-template-rows: repeat(3, auto);
  }

  &__slider {
    :deep(.content-block-large) {
      padding: 0;
      padding-bottom: px(30);
    }
  }

  .two-column-text {
    grid-row: 2 / 3;
  }
}
</style>
